import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { http } from "./api";

const SettingsContext = createContext(null);

const DEFAULT = {
  brand_name: "PRINTLAB",
  brand_accent: "#FF3B30",
  logo_url: null,
  hero_tagline: "Estudio de impresión bajo demanda",
  hero_line_1: "Diseña.",
  hero_line_2: "Personaliza.",
  hero_line_3: "Imprime.",
  hero_subheadline: "Sube tu arte, elige colores y tallas, y ve el mockup en tiempo real.",
  hero_cta_text: "Explorar productos",
  features: [],
  company_name: "Printlab Studio",
  company_email: "hola@printlab.mx",
  company_phone: "",
  company_whatsapp: "",
  company_address: "",
  company_city: "",
  company_hours: "",
  company_map_embed: null,
  bank_name: "",
  bank_beneficiary: "",
  bank_clabe: "",
  bank_email: "",
  social_links: [],
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await http.get("/settings");
      setSettings({ ...DEFAULT, ...data });
    } catch (err) {
      // Keep defaults on failure but log so we can debug config outages.
      console.warn("Failed to load /settings — using defaults:", err?.message || err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <SettingsContext.Provider value={{ settings, loading, refresh: load, setSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
